import { Injectable } from '@angular/core';
import mixpanel from 'mixpanel-browser';
import {environment} from '../../environments/environment';
import {AnalyticsEvent, UserState, UserTier} from '../models/AnalyticsModels';
import {UserModel} from '../models/User';
import {MembershipBucket} from '../models/SubscriptionsModels';
import {AuthService} from './auth.service';

function userTier(user: UserModel | null): MembershipBucket | UserTier {
    return user ? user.membershipBucket ?? MembershipBucket.Free : UserTier.Guest;
}

function userState(user: UserModel | null): UserState {
    return !user ? UserState.Anonymous : user.isPaid ? UserState.Paid : UserState.Free;
}

@Injectable({
  providedIn: 'root'
})
export class MixpanelService {
    private interactionCaptured = false;

  constructor(private auth: AuthService) {
    mixpanel.init(environment.mixPanelToken , {
        persistence: "cookie",
        cookie_domain: '.dollarflightclub.com',
        record_sessions_percent: 0,
        track_pageview: "full-url",
        record_heatmap_data: true,
        ...(environment.production ? { api_host: `${environment.apiBaseUrl}/proxy` } : {})
    });
      this.listenForFirstInteraction();

  }

    private listenForFirstInteraction() {
        if (typeof window === 'undefined') {
            return;
        }
        const events = ['pointerdown','scroll','keydown'];
        const startRecording = () => {
            if (this.interactionCaptured) {
                return;
            }
            this.interactionCaptured = true;

            const sampleRate = environment.production ? 0.05 : 0.01

            if (Math.random() < sampleRate) {
                mixpanel.start_session_recording();
            }
        };

        events.forEach(e =>
            window.addEventListener(e, startRecording, { passive: true, once: true })
        );
    }


    track(msg: string, properties: any = {}){
    mixpanel.track(msg,{signup_variant: 'B', user_state: userState(this.auth.getUser()), ...properties});
  }

  trackForUser(event: AnalyticsEvent, properties: Record<string, unknown> = {}): void {
    this.track(event, {user_tier: userTier(this.auth.getUser()), ...properties});
  }

  peopleSet(properties: any = {}){
    mixpanel.people.set(properties);
  }

  identify(id: string){
    mixpanel.identify(id);
  }

  reset(): void {
    mixpanel.reset();
  }
}
